import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageHeader } from "../../components/common";
import { COMPANY, Field, useOpsMeta, inp, btn } from "../../lib/ops";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const Shift = ({ co, v, ro, onChange }) => (
  <div className="ax-panel p-4" data-testid={`ops-shift-${co}`}>
    <div className="font-semibold text-sm mb-3">{COMPANY[co]}</div>
    <div className="flex flex-wrap gap-1.5 mb-3">{DAYS.map((l, i) => (
      <button key={l} disabled={ro} data-testid={`ops-shift-${co}-day-${i}`} onClick={() => onChange({ ...v, days: v.days.includes(i) ? v.days.filter((x) => x !== i) : [...v.days, i].sort() })}
        className={`h-9 w-12 text-xs border ${v.days.includes(i) ? "bg-primary text-primary-foreground border-primary" : ""}`}>{l}</button>))}</div>
    <div className="grid grid-cols-2 gap-3 mb-3">
      <Field label="Shift starts"><input type="time" disabled={ro} data-testid={`ops-shift-${co}-start`} value={v.start} onChange={(e) => onChange({ ...v, start: e.target.value })} className={inp} /></Field>
      <Field label="Shift ends"><input type="time" disabled={ro} data-testid={`ops-shift-${co}-end`} value={v.end} onChange={(e) => onChange({ ...v, end: e.target.value })} className={inp} /></Field>
    </div>
    <Field label="Holidays (one date per line, e.g. 2026-11-08)"><textarea disabled={ro} data-testid={`ops-shift-${co}-holidays`} value={v.hol} onChange={(e) => onChange({ ...v, hol: e.target.value })} className="w-full bg-muted/60 border p-2 text-sm h-24 font-mono" /></Field>
  </div>
);

export default function OpsSettings() {
  const meta = useOpsMeta();
  const [f, setF] = useState(null);
  useEffect(() => {
    if (meta) setF({ cal: Object.fromEntries(Object.entries(meta.calendar).map(([k, c]) => [k, { ...c, hol: (c.holidays || []).join("\n") }])), lib: meta.library.join("\n") });
  }, [meta]);
  if (!f) return <div className="text-sm text-muted-foreground">Loading…</div>;
  const ro = !meta.can.approve;
  const save = () => api.put("/ops/settings", {
    calendar: Object.fromEntries(Object.entries(f.cal).map(([k, c]) => [k, { days: c.days, start: c.start, end: c.end, holidays: c.hol.split(/\s+/).filter(Boolean) }])),
    library: f.lib.split("\n"),
  }).then(() => toast.success("Settings saved")).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="max-w-4xl">
      <PageHeader eyebrow="Operations" title="Shifts & steps" desc="Reminders go out only inside these shifts (India time), and working days drive planned durations and forecasts." />
      <div className="grid md:grid-cols-2 gap-3 mb-4">{Object.keys(COMPANY).map((co) => f.cal[co] && <Shift key={co} co={co} v={f.cal[co]} ro={ro} onChange={(v) => setF({ ...f, cal: { ...f.cal, [co]: v } })} />)}</div>
      <div className="ax-panel p-4 mb-4">
        <Field label="Step names offered when planning (one per line; people can still type a new one)"><textarea disabled={ro} data-testid="ops-library-input" value={f.lib} onChange={(e) => setF({ ...f, lib: e.target.value })} className="w-full bg-muted/60 border p-2 text-sm h-64" /></Field>
      </div>
      {!ro && <button data-testid="ops-settings-save" onClick={save} className={btn}>Save settings</button>}
    </div>
  );
}
